import { Box, Button, Divider, Typography } from '@mui/material';
import React from 'react';

/**
 * Composant pour afficher le rendu d'une actualité à partir de son contenu JSON
 */
const NewsRenderer = ({ content }) => {
  if (!content || !content.blocks || content.blocks.length === 0) {
    return (
      <Typography color="text.secondary">
        Aucun contenu à afficher
      </Typography>
    );
  }

  const renderBlock = (block) => {
    switch (block.type) {
      case 'title':
        const TitleTag = block.data.level || 'h2';
        return (
          <Typography
            key={block.id}
            variant={block.data.level || 'h2'}
            component={TitleTag}
            sx={{ mb: 2, fontWeight: 'bold' }}
          >
            {block.data.text}
          </Typography>
        );

      case 'text':
        return (
          <Typography
            key={block.id}
            sx={{
              mb: 2,
              textAlign: block.data.align || 'left',
              whiteSpace: 'pre-wrap',
            }}
          >
            {block.data.text}
          </Typography>
        );

      case 'image':
        return (
          <Box key={block.id} sx={{ mb: 3, textAlign: 'center' }}>
            <Box
              component="img"
              src={block.data.url.startsWith('http') 
                ? block.data.url 
                : `${'https://api.inklandtattoo.fr'}${block.data.url}`}
              alt={block.data.alt || 'Image'}
              sx={{
                maxWidth: '100%',
                height: 'auto',
                borderRadius: 1,
              }}
            />
            {block.data.caption && (
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: 'block', mt: 1, fontStyle: 'italic' }}
              >
                {block.data.caption}
              </Typography>
            )}
          </Box>
        );

      case 'video':
        return (
          <Box key={block.id} sx={{ mb: 3, textAlign: 'center' }}>
            <Box
              component="video"
              src={block.data.url.startsWith('http') 
                ? block.data.url 
                : `${'https://api.inklandtattoo.fr'}${block.data.url}`}
              controls
              autoPlay={block.data.autoplay || false}
              loop={block.data.loop || false}
              sx={{
                maxWidth: '100%',
                height: 'auto',
                borderRadius: 1,
              }}
            />
            {block.data.caption && (
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: 'block', mt: 1, fontStyle: 'italic' }}
              >
                {block.data.caption}
              </Typography>
            )}
          </Box>
        );

      case 'gif':
        return (
          <Box key={block.id} sx={{ mb: 3, textAlign: 'center' }}>
            <Box
              component="img"
              src={block.data.url.startsWith('http') 
                ? block.data.url 
                : `${'https://api.inklandtattoo.fr'}${block.data.url}`}
              alt={block.data.caption || 'GIF'}
              sx={{
                maxWidth: '100%',
                height: 'auto',
                borderRadius: 1,
              }}
            />
            {block.data.caption && (
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: 'block', mt: 1, fontStyle: 'italic' }}
              >
                {block.data.caption}
              </Typography>
            )}
          </Box>
        );

      case 'button':
        return (
          <Box key={block.id} sx={{ mb: 2, textAlign: 'center' }}>
            <Button
              variant={block.data.variant || 'contained'}
              color={block.data.color || 'primary'}
              href={block.data.url}
              sx={{ minWidth: 200 }}
            >
              {block.data.text}
            </Button>
          </Box>
        );

      case 'divider':
        return (
          <Divider
            key={block.id}
            sx={{
              my: 2,
              borderStyle: block.data.style || 'solid',
            }}
          />
        );

      case 'spacer':
        return (
          <Box
            key={block.id}
            sx={{
              height: block.data.height || 20,
            }}
          />
        );

      default:
        return null;
    }
  };

  return (
    <Box>
      {content.blocks.map((block) => renderBlock(block))}
    </Box>
  );
};

export default NewsRenderer;

